import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from react-dom/client
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Ensure correct path
import ThemeWrapper from './components/ThemeWrapper'; // Ensure correct path
import { ApiProvider } from './components/Context/ApiContext'; // Correct the path here
import './index.css'; // Import global styles
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import App from './App'; // Import the main App component
import axiosInstance, { getApiBaseUrl } from '../src/components/services/axiosInstance.js';

// Initialize translations and i18n before rendering the app
const initializeApp = async () => {
  try {
    // Fetch and set up translations
    await i18n.init({
      lng: 'en-GB', // Default language
      fallbackLng: 'en-GB',
      interpolation: {
        escapeValue: false, // React already safes from xss
      },
      backend: {
        // Use centralized base URL for API
        loadPath: `${getApiBaseUrl()}/locales/{{lng}}/translation.json`, // Dynamically get the base URL
      },
    });
    console.log('i18n initialized successfully');
  } catch (error) {
    console.error('Error initializing i18n:', error);
    // Handle error case or set fallback language if needed
  }
};

// Call the initialization function and then render the app
initializeApp().then(() => {
  // Create the root using createRoot for React 18
  const root = ReactDOM.createRoot(document.getElementById('root'));

  // Render the app within the created root using React.createElement instead of JSX
  root.render(
    React.createElement(React.StrictMode, null, 
      React.createElement(I18nextProvider, { i18n: i18n }, 
        React.createElement(BrowserRouter, null, 
          React.createElement(ApiProvider, null, 
            React.createElement(ThemeWrapper, null, 
              React.createElement(App, null)
            )
          )
        )
      )
    )
  );
}).catch(error => {
  console.error('Error during app initialization:', error);
  // Optionally render a fallback UI or message
});
